import { render } from "./CommCss.vue?vue&type=template&id=22e7e912"
import script from "./CommCss.vue?vue&type=script&lang=js"
export * from "./CommCss.vue?vue&type=script&lang=js"

import "./CommCss.vue?vue&type=style&index=0&id=22e7e912&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__